import Component from '../Component';
import Routes from '../../routes';

export default class Location extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    return super.initialize();
  }

  search(query, callback) {

    return this.App.API.get(Routes.API.CONTENT.GEO.LOCATION, {
      query: query
    }).then((response) => {

      if (response.data) {

        if (response.data.data === null) {

          callback(null);
          return this.App.UI.Dialog.alert(
            this.App.Language.get('errors.zero_results')
          );

        } else if (typeof response.data.data == 'object') {
          return callback(response.data.data);
        }

      }

      callback(null);

      return this.App.UI.Dialog.alert(
        this.App.Language.get('errors.internal_error')
      );

    }).catch((error) => {

      callback(null);

      return this.App.UI.Dialog.alert(
        this.App.Language.get('errors.internal_error')
      );

    });

  }
}